var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFvBackLeft02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 453,
    viewBox: "0 0 540 453",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.332 238.423L2.68799 277.689C3.36946 279.126 4.16204 280.504 5.07314 281.815L41.7319 240.268C40.3468 239.542 38.8727 238.927 37.3394 238.423H37.332Z",
    fill: "#C7CFE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4955 237.068L-0.000488281 267.098C0.110621 269.068 0.414314 271.001 0.918011 272.875L32.3398 237.268C30.3769 236.994 28.4214 236.935 26.4955 237.068Z",
    fill: "#C7CFE4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.07393 257.608C0.881335 258.275 0.725783 258.942 0.577637 259.616L19.133 238.586C10.6886 241.52 3.74796 248.364 1.07393 257.608Z",
    fill: "#C7CFE4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0288 258.171L24.6069 293.778C26.5699 294.052 28.5254 294.112 30.4513 293.978L56.9473 263.949C56.8361 261.979 56.5325 260.045 56.0288 258.171Z",
    fill: "#C7CFE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.592 242.713L7.97021 285.349C9.00724 286.431 10.1406 287.431 11.3479 288.342L48.9697 245.705C47.9253 244.624 46.7993 243.624 45.5845 242.713H45.592Z",
    fill: "#C7CFE4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.814 292.468C46.2583 289.535 53.199 282.69 55.873 273.446C56.0656 272.779 56.2211 272.113 56.3693 271.438L37.814 292.468Z",
    fill: "#C7CFE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8731 249.239L15.2144 290.787C16.5995 291.513 18.0736 292.128 19.6069 292.631L54.2509 253.365C53.5694 251.928 52.7768 250.55 51.8657 249.239H51.8731Z",
    fill: "#C7CFE4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M155 94C155 90.684 157.684 88 161 88C164.315 88 167 90.684 167 94C167 97.316 164.315 100 161 100C157.684 100 155 97.316 155 94Z",
    fill: "#C7CFE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M237.32 328.401C239.665 326.056 243.461 326.056 245.806 328.4C248.15 330.745 248.15 334.541 245.806 336.886C243.461 339.231 239.665 339.231 237.32 336.886C234.976 334.541 234.976 330.745 237.32 328.401Z",
    fill: "#C7CFE4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.712 212.081C190.736 211.105 189.153 211.105 188.177 212.081C187.2 213.058 187.2 214.641 188.177 215.617C189.153 216.593 190.736 216.593 191.712 215.617C192.688 214.641 192.688 213.058 191.712 212.081Z",
    fill: "url(#paint0_linear_685_5647)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M537.487 324.511C536.511 323.535 534.928 323.535 533.951 324.511C532.975 325.487 532.975 327.07 533.951 328.047C534.928 329.023 536.511 329.023 537.487 328.047C538.463 327.07 538.463 325.487 537.487 324.511Z",
    fill: "#C7CFE4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.485 317.087C93.3134 315.915 91.5722 315.757 90.5959 316.733C89.6196 317.71 89.7779 319.451 90.9495 320.622C92.121 321.794 93.8623 321.952 94.8386 320.976C95.8149 320 95.6566 318.258 94.485 317.087Z",
    fill: "#C7CFE4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 5.32031C224.881 5.32031 226 4.20105 226 2.82033C226 1.43962 224.881 0.320312 223.5 0.320312C222.119 0.320312 221 1.43962 221 2.82033C221 4.20105 222.119 5.32031 223.5 5.32031Z",
    fill: "#C7CFE4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5453 251.68C93.7879 249.922 90.9387 249.922 89.1813 251.68C87.4239 253.437 87.424 256.286 89.1813 258.044C90.9387 259.801 93.7879 259.801 95.5453 258.044C97.3026 256.286 97.3026 253.437 95.5453 251.68Z",
    fill: "#C7CFE4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M408.794 447.548C407.817 446.572 406.234 446.572 405.258 447.548C404.282 448.525 404.282 450.107 405.258 451.084C406.234 452.06 407.817 452.06 408.794 451.084C409.77 450.107 409.77 448.525 408.794 447.548Z",
    fill: "#C7CFE4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M493.647 434.82C492.67 433.844 491.087 433.844 490.111 434.82C489.135 435.797 489.135 437.379 490.111 438.356C491.087 439.332 492.67 439.332 493.647 438.356C494.623 437.379 494.623 435.797 493.647 434.82Z",
    fill: "url(#paint1_linear_685_5647)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M353.639 327.34C352.663 326.364 350.922 326.522 349.75 327.694C348.579 328.865 348.42 330.607 349.397 331.583C350.373 332.559 352.114 332.401 353.286 331.229C354.457 330.058 354.616 328.316 353.639 327.34Z",
    fill: "#C7CFE4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M470.312 444.013C469.336 443.036 467.595 443.195 466.423 444.366C465.252 445.538 465.093 447.279 466.07 448.255C467.046 449.231 468.787 449.073 469.959 447.902C471.13 446.73 471.289 444.989 470.312 444.013Z",
    fill: "#C7CFE4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M479.151 317.087C477.589 315.525 475.056 315.525 473.494 317.087C471.932 318.649 471.932 321.182 473.494 322.744C475.056 324.306 477.589 324.306 479.151 322.744C480.713 321.182 480.713 318.649 479.151 317.087Z",
    fill: "#C7CFE4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M286.818 202.535C284.865 200.583 281.699 200.583 279.747 202.535C277.794 204.488 277.794 207.654 279.747 209.607C281.699 211.559 284.865 211.559 286.818 209.607C288.77 207.654 288.77 204.488 286.818 202.535Z",
    fill: "#C7CFE4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_685_5647",
    x1: 191.712,
    y1: 215.617,
    x2: 188.177,
    y2: 212.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C44A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_685_5647",
    x1: 493.647,
    y1: 438.356,
    x2: 490.106,
    y2: 434.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9C44A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFvBackLeft02);
export default __webpack_public_path__ + "static/media/fv-back__left02.542bf469b4740b4a23bd7c1522d4e714.svg";
export { ForwardRef as ReactComponent };